import React, { useEffect, useState } from "react";
import axios from "axios";
import { Select, Typography, message } from "antd";
import { ListaItems } from "../../../../Components/Items";
import { WA } from "../theme";
import { formatTelefono } from "../../../../Utils/whatsapp.utils";

const { Text } = Typography;

const nombreConv = (conv) => {
  if (conv.contactoId?.nombre) {
    return `${conv.contactoId.nombre} ${conv.contactoId.apellidoPaterno || ""}`.trim();
  }
  return conv.nombrePerfilWa || formatTelefono(conv.telefono);
};

const AsignarConversaciones = ({ headersToken, empresaId }) => {
  const [conversaciones, setConversaciones] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [guardandoId, setGuardandoId] = useState(null);

  const headers = { headers: headersToken };

  useEffect(() => {
    axios
      .post("usuarios/selectUsuariosEmpresa", { empresaId }, headers)
      .then((r) => {
        if (Array.isArray(r.data)) setUsuarios(r.data);
      });
    axios
      .post("whatsapp/listarConversaciones", { todas: true }, headers)
      .then((r) => {
        if (r.data.success === 2) setConversaciones(r.data.conversaciones || []);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const asignar = (conversacionId, nuevoUsuarioId) => {
    setGuardandoId(conversacionId);
    axios
      .post("whatsapp/asignarConversacion", { conversacionId, nuevoUsuarioId }, headers)
      .then((r) => {
        if (r.data.success === 2) {
          message.success("Conversación asignada.");
          setConversaciones((prev) =>
            prev.map((c) => (c._id === conversacionId ? r.data.conversacion : c)),
          );
        } else {
          message.error(r.data.message || "No se pudo asignar.");
        }
      })
      .catch(() => message.error("Error de red al asignar."))
      .finally(() => setGuardandoId(null));
  };

  return (
    <ListaItems
      dataSource={conversaciones}
      loading={loading}
      vacioTexto="Sin conversaciones para asignar"
      titulo={(conv) => <Text style={{ color: WA.textPrimary }}>{nombreConv(conv)}</Text>}
      descripcion={(conv) => (
        <Text style={{ fontSize: 12, color: WA.textSecondary }}>
          {formatTelefono(conv.telefono)}
        </Text>
      )}
      acciones={(conv) => [
        <Select
          key="sel"
          style={{ width: 220 }}
          placeholder="Sin asignar"
          allowClear
          value={conv.asignadoAUsuarioId?._id || undefined}
          loading={guardandoId === conv._id}
          onChange={(val) => asignar(conv._id, val || null)}
          showSearch
          filterOption={(input, opt) => opt.children.toLowerCase().includes(input.toLowerCase())}
        >
          {usuarios.map((u) => (
            <Select.Option key={u._id} value={u._id}>
              {`${u.nombre} ${u.apellidoPaterno || ""}`.trim()}
            </Select.Option>
          ))}
        </Select>,
      ]}
    />
  );
};

export default AsignarConversaciones;
